import { cdnImage, CDNImageProps } from '@/utils/image-utils';
import { envIsCanada, envIsMexico, envIsSweden } from '@/constants/constants';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import classNames from 'classnames';

const desktopProps: CDNImageProps = { width: '1920', height: '900', fit: 'crop' };
const tabletProps: CDNImageProps = { width: '960', height: '900', fit: 'crop' };
const mobileProps: CDNImageProps = { width: '640', height: '900', fit: 'crop' };

const BG_LARGE_NORMAL = cdnImage('luckydays-beach.jpg', desktopProps);
const BG_MEDIUM_NORMAL = cdnImage('luckydays-beach.jpg', tabletProps);
const BG_SMALL_NORMAL = cdnImage('luckydays-beach.jpg', { ...mobileProps, gravity: 'right' });

const BG_LARGE_MEXICO = cdnImage('ld_mexico_bg_desktop.jpg', desktopProps);
const BG_MEDIUM_MEXICO = cdnImage('ld_mexico_bg_desktop.jpg', tabletProps);
const BG_SMALL_MEXICO = cdnImage('ld_mexico_bg_mobile.jpg', mobileProps);

const BG_LARGE_CANADA = cdnImage('ont-reg-desktop.jpg', desktopProps);
const BG_MEDIUM_CANADA = cdnImage('ont-reg-tablet.jpg', tabletProps);
const BG_SMALL_CANADA = cdnImage('ont-reg-mobile.jpg', mobileProps);

const BG_LARGE_THAILAND = cdnImage('thailand-bg-desktop.jpg', desktopProps);
const BG_MEDIUM_THAILAND = cdnImage('thailand-bg-tablet.jpg', tabletProps);
const BG_SMALL_THAILAND = cdnImage('thailand-bg-mobile.jpg', mobileProps);

const getBgLarge = (locale: string) => {
  if (envIsMexico()) {
    return BG_LARGE_MEXICO;
  }

  if (envIsCanada()) {
    return BG_LARGE_CANADA;
  }

  // Normal and Sweden
  if (locale === 'th') {
    return BG_LARGE_THAILAND;
  }

  return BG_LARGE_NORMAL;
};

const getBgMedium = (locale: string) => {
  if (envIsMexico()) {
    return BG_MEDIUM_MEXICO;
  }

  if (envIsCanada()) {
    return BG_MEDIUM_CANADA;
  }

  // Normal and Sweden

  if (locale === 'th') {
    return BG_MEDIUM_THAILAND;
  }

  return BG_MEDIUM_NORMAL;
};

const getBgSmall = (locale: string) => {
  if (envIsMexico()) {
    return BG_SMALL_MEXICO;
  }

  if (envIsCanada()) {
    return BG_SMALL_CANADA;
  }

  // Normal and Sweden

  if (locale === 'th') {
    return BG_SMALL_THAILAND;
  }

  return BG_SMALL_NORMAL;
};

const HeroLayout = ({
  children,
  isAuthenticated,
  fullHeight = false,
}: {
  children: React.ReactNode;
  isAuthenticated: boolean;
  fullHeight?: boolean;
}): JSX.Element => {
  const locale = useSelector(selectLocale);

  const bgLarge = getBgLarge(locale);
  const bgMedium = getBgMedium(locale);
  const bgSmall = getBgSmall(locale);

  return (
    <div
      className={classNames(
        'relative bg-luckyBlue2 flex items-center justify-center',
        envIsSweden() ? 'min-h-heroMobileHeightSweden' : 'min-h-heroMobileHeight',
        isAuthenticated
          ? 'min-h-[calc(90vh-56px-57px-28px)]'
          : 'min-h-[calc(100vh-56px-57px)] lg:min-h-screen',
        { 'min-h-screen': fullHeight },
      )}
    >
      <div className="absolute left-0 right-0 bottom-0 top-0 after:absolute after:right-0 after:left-0 after:bottom-0 after:top-0 after:bg-black/50 z-0">
        <picture className="w-full h-full object-cover object-center">
          <source media="(max-width: 640px)" srcSet={bgSmall} />
          <source media="(max-width: 960px)" srcSet={bgMedium} />
          <img
            className="object-cover object-center w-full h-full"
            src={bgLarge}
            alt="Lucky the cat on his way to the beach"
          />
        </picture>
      </div>
      {children}
    </div>
  );
};

export default HeroLayout;
